import axios from "@/api/http";
const BASE_URL = process.env.VUE_APP_LOGISTICS_URL;
/**
 * 集配后台-送货进度跟踪
 * @param {*} params
 * @returns
 */
export function getDeliveryProgress(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/supplier/order/deliver/progress`,
    data: params,
  });
}

/**
 * 集配后台-送货记录查询
 * @param {*} params
 * @returns
 */
export function getDeliveryRecord(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/supplier/order/deliver/record`,
    data: params,
  });
}

/**
 * 集配后台-供货单号列表
 * @param {*} params
 * @returns
 */
export function getEntruckDeliverylist(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/supplier/order/select/list`,
    data: params,
  });
}

/**
 * 集配后台-业务员列表
 * @param {*} params
 * @returns
 */
export function postBuyerSelectList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/buyer/select/list`,
    data: params,
  });
}

/**
 * 集配后台-供货商列表
 * @param {*} params
 * @returns
 */ 
export function postSupplierSelectList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/supplier/select/list`,
    data: params,
  });
}

/**
 * 集配后台-品控复核-线上
 * @param {*} params
 * @returns
 */
export function postQualityControlReviewOnline(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/entruck/list/online`,
    data: params,
  });
}

/**
 * 集配后台-品控复核-确认复核
 * @param {*} params
 * @returns
 */
export function postlReviewOnlineConfirmAll(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/entruck/setOnlineQcConfirmAll`,
    data: params,
  });
}

/**
 * 集配后台-品控复核-线上-批量修改缺货原因
 * @param {*} params
 * @returns
 */
export function postUpdateOnlineQcReason(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/entruck/list/saveQcReason`,
    data: params,
  });
}

/**
 * 集配后台-送货视频
 * @param {*} params
 * @returns
 */
export function getDeliveryVideo(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/supplier/order/deliver/video`,
    data: params,
  });
}

/**
 * 集配后台-上车记录
 * @param {*} params
 * @returns
 */
export function getBoardingRecordList(params = {}) {
  return axios({
    method: "POST",
    url: `${BASE_URL}/supplier/order/deliver/log`,
    data: params,
  });
}

/**
 * 集配后台-送货记录导出
 * @param {*} params
 * @returns
 */
export function exportDeliveryRecord(params = {}) {
  return axios({
    method: "GET",
    url: `${BASE_URL}/supplier/order/deliver/record/export`,
    data: params,
    responseType: "blob",
  });
}

/**
 * 集配后台-品控复核-线上-导出
 * @param {*} params
 * @returns
 */
export function exportOnlineReviewList(params = {}) {
  return axios({
    method: "GET",
    url: `${BASE_URL}/entruck/list/online/export`,
    responseType: "blob",
    data: params,
  });
}
